// Column Block - Two column layout
class ColumnBlock {
  static get toolbox() {
    return {
      title: 'Columns',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="3" x2="12" y2="21"></line></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      left: data.left || '',
      right: data.right || ''
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="grid grid-cols-2 gap-4 p-4 rounded-lg border border-slate-200 dark:border-slate-700" data-testid="column-block">
        <div class="left-col p-3 min-h-[100px] rounded bg-slate-50 dark:bg-slate-800">
          <div class="left-content text-slate-700 dark:text-slate-300" contenteditable="${!this.readOnly}" data-placeholder="Left column...">${this.data.left}</div>
        </div>
        <div class="right-col p-3 min-h-[100px] rounded bg-slate-50 dark:bg-slate-800">
          <div class="right-content text-slate-700 dark:text-slate-300" contenteditable="${!this.readOnly}" data-placeholder="Right column...">${this.data.right}</div>
        </div>
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelector('.left-content')?.addEventListener('input', (e) => {
        this.data.left = e.target.innerHTML;
      });
      this.wrapper.querySelector('.right-content')?.addEventListener('input', (e) => {
        this.data.right = e.target.innerHTML;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default ColumnBlock;
